<template>
  <v-card class="mx-auto" flat>
    <v-card-title>
      My Approval List
      <v-spacer />
      <v-toolbar dense flat>
        <v-chip-group v-model="approvalFilters" column mandatory @change="onChangeStatusfilter">
          <v-chip v-for="(status) in approvalStatus" :key="`v-chip-status-${status.value}`" filter outlined color="info"
            :value="status.value">
            {{ status.title }}
          </v-chip>
        </v-chip-group>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line dense outlined
        hide-details></v-text-field>
    </v-card-title>

    <v-card-text class="mt-8">
      <v-data-table :headers="headers" :items="approvals" class="elevation-2 rounded-xl my-data-table"
        @click:row="(item) => rowEvents(item, true)" show-select>
        <template #top>
          <v-toolbar flat color="#f5fcff" class="rounded-t-xl pr-3">
            <v-spacer></v-spacer>
            <v-card color="transparent" class="rounded-lg pt-7" width="500" elevation="0" style="overflow-y: hidden;"
              v-if="filterByType">
              <v-card-text class="pa-0">
                <v-autocomplete outlined rounded autofocus clearable class="mx-4 my-4" :items="filterItems"
                  placeholder="Start typing to search filters" item-text="name" item-value="name"
                  no-data-text="No filters available at the moment" color="info" @click:clear="onClearSearchContent"
                  v-model="filterTextContent">
                  <template #append>
                    <v-icon @click="useTypeFilter" color="info">mdi-magnify</v-icon>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-card>
            <v-btn outlined fab color="info" @click="setTypeFilterControl" v-else>
              <v-icon size="30">mdi-filter-variant</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divder />
        </template>
        <template v-slot:item.approveForType="{ item }">
          {{ getHintedDocType(item.recordToApprove) }}
        </template>
        <template v-slot:item.sendByName="{ item }">
          {{ getEmployee(item.sendByName) }}
        </template>
        <template v-slot:item.dueDate="{ item }">
          <span>{{ getDate(item.dueDate) }}</span>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" outlined>
            {{ item.status == "Open" ? "Pending Approval" : item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <!--<v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success" elevation="0" @click="approveRequest(item)" class="rounded-xl" v-bind="attrs"
                v-on="on">
                <span style="text-transform: capitalize;">Approve</span>
              </v-btn>
            </template>
<span>Approve this approval request without going to details.? You will not leave a comment too.</span>
</v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" text elevation="0" @click="viewApproval(item)" v-bind="attrs" v-on="on">
                <span style="text-transform: capitalize; text-decoration: underline;">View</span>
              </v-btn>
            </template>
            <span>Click to see details of this approval request</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
    <ApprovalDetailsDrawer :showApprovalRecordDetails="showApprovalRecordDetails"
      @toggle-approval-details-drawer="rowEvents" />
  </v-card>
</template>
<script>
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";
import { helper } from "@kinetics254/cassandra-base/utilities";
import ApprovalDetailsDrawer from "./ApprovalDetailsDrawer.vue";

export default {
  name: "ApprovalList",

  components: { ApprovalDetailsDrawer },
  data() {
    return {
      filterTextContent: "",
      filterByType: false,
      approvalFilters: '',
      showApprovalRecordDetails: false,
      search: "",
      selectedGroup: "",
      tabs: "All",
      status: ["All", "Pending", "Approved"],
    };
  },
  computed: {
    filterItems() {
      return [
        {
          name: 'Requisition'
        },
        {
          name: 'Leave'
        },
        {
          name: 'Imprest'
        },
        {
          name: 'Petty Cash'
        }
      ]
    },
    userData() {
      return AuthService.user;
    },
    approvalStatus() {
      return [
        {
          title: 'Pending',
          value: 'Open',
        },
        {
          title: 'Approved',
          value: 'Approved',
        },
        {
          title: 'Rejected',
          value: 'Rejected',
        },
        {
          title: 'All',
          value: 'All',
        }
      ]
    },
    approvals() {
      const approvals =
        this.$store.getters["Approvals/approvalGetters"]("approvalEntries");
      return approvals.data
        ? approvals.data
          .sort((a, b) => {
            return new Date(b.dueDate) - new Date(a.dueDate);
          })
          .filter((el) => {
            return this.tabs === "Pending" ? el.status === "Open" : el;
          })
          .filter((el) => {
            return this.tabs === "Approved" ? el.status !== "Open" : el;
          })
          .filter((el) =>
            this.selectedGroup.length > 0
              ? el.approveForType === this.selectedGroup
              : true
          )
        : [];
    },
    approvalGroups() {
      const approvals =
        this.$store.getters["Approvals/approvalGetters"]("approvalEntries");
      return approvals.groups
        ? approvals.groups.map((el) => {
          return {
            text: el.approveForType,
            value: approvals.data.filter(
              (item) => item.approveForType === el.approveForType
            ).length,
          };
        })
        : [];
    },
    employees() {
      return this.$store.getters["Setup/setupGetter"]("leaveEmployees");
    },
    headers() {
      return [
        {
          text: "Document no.",
          align: "start",
          sortable: true,
          value: "documentNo",
        },
        {
          text: "Document type",
          align: "start",
          sortable: true,
          value: "approveForType",
        },
        {
          text: "Sent by",
          align: "start",
          sortable: true,
          value: "sendByName",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "Due on",
          align: "start",
          sortable: true,
          value: "dueDate",
        },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    initiateFetchApprovalList(query = {}) {
      this.$store.dispatch("Approvals/getApprovalEntries", {
        approverID: this.userData.employee,
        status: this.approvalFilters,
        ...query,
      });
    },
    onChangeStatusfilter() {
      this.initiateFetchApprovalList();
    },
    onClearSearchContent() {
      this.filterTextContent = "";
      this.filterByType = false;
    },
    getHintedDocType(str) {
      if (!str) return;
      const hints = {
        purchase: 'Purchase Requisition',
        store: 'Store Requisition',
        user: 'User Requisition',
        leave: 'Leave',
        imprest: 'Imprest',
        petty: 'Petty Cash',
      };
      let documentType = '';
      for (const key of Object.keys(hints)) {
        if (str.toLowerCase().includes(key)) {
          documentType = hints[key];
        }
      }
      return documentType;
    },
    useTypeFilter() {
      const filter = this.filterTextContent.trim();
      if (!filter || filter === '') return;
      let needle = null;
      switch (filter.toLowerCase()) {
        case 'leave': {
          needle = "Leave";
          break;
        }
        case 'purchase requisition': {
          needle = 'Purchase'
          break;
        }
        case 'store requisition': {
          needle = 'Store';
          break;
        }
        case 'user requisition': {
          needle = 'User';
          break;
        }
        case 'imprest': {
          needle = 'Imprest';
          break;
        }
        case 'petty cash': {
          needle = 'Petty'
          break;
        }
        default: throw new Error('Invalid options');
      }
      if (needle) {
        this.initiateFetchApprovalList({
          needle,
        })
      }
      this.filterByType = false;
    },
    setTypeFilterControl() {
      this.filterByType = true;
    },
    rowEvents(item, show) {
      console.log("event triggered!");

      // this.showApprovalRecordDetails = show;
      // this.viewApproval(item);
    },
    getEmployee(identifier) {
      const employee = this.employees.filter((e) => e.number === identifier || e.user_id === identifier)[0];
      return employee
        ? employee.search_name.length > 0
          ? employee.search_name
          : `${employee.first_name} ${employee.middle_name} ${employee.last_name}`
        : "";
    },
    getDate(date) {
      return helper.getDateFormat(date);
    },
    getStatusColor(status) {
      return helper.getColor(status).color;
    },
    splitHeader(item) {
      const RecHeader = item.recordToApprove.split(":")[0];
      console.log(RecHeader);
      return RecHeader;
    },
    viewApproval(item) {
      const RecHeader = item.recordToApprove.split(":")[0];
      console.log(RecHeader);
      if (RecHeader !== "Emp. Perf. Application Header") {
        this.$router.push({
          name: "ApprovalCard",
          query: {
            documentNo: btoa(item.documentNo),
            approverID: btoa(item.approverID),
            status: btoa(item.status),
          },
          params: {
            documentNo: btoa(item.documentNo),
            approverID: btoa(item.approverID),
            status: btoa(item.status),
          },
        });
      } else {
        this.$router.push({
          name: "AppraisalApprovalCard",
          params: {
            documentNo: btoa(item.documentNo),
            status: btoa(item.status),
          },
        });
      }
    },
  },
};
</script>
